export default __webpack_public_path__ + "static/ministry-f26a10de780c83d1f2d5e6f745760dd0.png";